import { render, staticRenderFns } from "./PaymentFeeEditDialog.vue?vue&type=template&id=3b6b1937&scoped=true"
import script from "./PaymentFeeEditDialog.vue?vue&type=script&lang=js"
export * from "./PaymentFeeEditDialog.vue?vue&type=script&lang=js"
import style0 from "./PaymentFeeEditDialog.vue?vue&type=style&index=0&id=3b6b1937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b1937",
  null
  
)

export default component.exports